import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';

import './NavLinks.scss';
import Avatar from '../../UIElements/Avatar/Avatar';
import { AuthContext } from '../../../context/auth-context';
import { LanguageContext } from '../../../context/language-context';

const NavLinks = ({ className }) => {
  const auth = useContext(AuthContext);
  const lng = useContext(LanguageContext);

  return (
    <ul className={`nav-links ${className}`}>
      {!auth.isLoggedIn && (
        <React.Fragment>
          <li>
            <NavLink to="/products">
              {lng.language === 'en' ? 'products' : '商品情報'}
            </NavLink>
          </li>
          <li>
            <NavLink to="/stores">
              {lng.language === 'en' ? 'stores' : '店舗情報'}
            </NavLink>
          </li>
          <li>
            <NavLink to="/about">
              {lng.language === 'en' ? 'about' : '私たち'}
            </NavLink>
          </li>
          <li>
            <NavLink to="/news">
              {lng.language === 'en' ? 'news' : 'お知らせ'}
            </NavLink>
          </li>
          <li>
            <NavLink to="/careers">
              {lng.language === 'en' ? 'careers' : '採用情報'}
            </NavLink>
          </li>
        </React.Fragment>
      )}
      {auth.admin && (
        <React.Fragment>
          <li>
            <NavLink to="/products">
              {lng.language === 'en' ? 'products' : '商品'}
            </NavLink>
          </li>
          <li>
            <NavLink to="/posts">
              {lng.language === 'en' ? 'posts' : 'お知らせ'}
            </NavLink>
          </li>
          <li>
            <NavLink to="/settings">
              {lng.language === 'en' ? 'settings' : '設定'}
            </NavLink>
          </li>
          <li>
            <button className="nav-links__logout-btn" onClick={auth.logout}>
              {lng.language === 'en' ? 'sign out' : 'サインアウト'}
            </button>
          </li>
          <li className="nav-links__avatar">
            <NavLink to="/settings">
              <Avatar
                filename={auth.admin.photo}
                alt={`portrait of ${auth.admin.name}`}
                width="50px"
                height="50px"
              />
            </NavLink>
          </li>
        </React.Fragment>
      )}
    </ul>
  );
};

export default NavLinks;
